module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-md-9': _vm.showSuggestions, 'col-md-12': !_vm.showSuggestions, 'suggestions-showing': _vm.showSuggestions
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.Title
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.FirstName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.MiddleName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.LastName
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6"
  }, [_c('datepicker', {
    attrs: {
      "controller": _vm.controller.Dob,
      "end-date": _vm.today,
      "start-date": "01/01/1900"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.NhsId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6"
  }, [_c('formselect', {
    attrs: {
      "controller": _vm.controller.Sex,
      "options": _vm.sexOptions
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "well well-sm"
  }, [_vm._v("\n                    Address\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.addressLine
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.PostCode
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.controller) ? _c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.controller.hasError) ? _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": this.isWorking
    },
    on: {
      "click": _vm.SavePatient
    }
  }, [(this.isWorking) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e(), _vm._v(" Save")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "disabled": this.isWorking
    },
    on: {
      "click": _vm.Reset
    }
  }, [_vm._v("Reset")])]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2aff0036", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aff0036"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/NewPatientForm/NewPatientForm.scp.html
// module id = 462
// module chunks = 0